import React from "react"
import "twin.macro"
import WebSvg, { FreeSvg, MarketSvg, UserSvg } from "../../images/svg"
const ServiceData = [
  {
    title: "Skill 1",
    svg: MarketSvg,
    content: `Maecenas laoreet augue egestas laoreet augue egestas, congue gestas
          volutpat posuere cubilia congue ipsum mauris lectus laoreet gestas
          neque volutpat and gestas posuere congue ipsum.`,
  },
  {
    title: "Skill 2",
    svg: UserSvg,
    content: `Maecenas laoreet augue egestas laoreet augue egestas, congue gestas
          volutpat posuere cubilia congue ipsum mauris lectus laoreet gestas
          neque volutpat and gestas posuere congue ipsum.`,
  },
  {
    title: "Skill 3",
    svg: WebSvg,
    content: `Maecenas laoreet augue egestas laoreet augue egestas, congue gestas
          volutpat posuere cubilia congue ipsum mauris lectus laoreet gestas
          neque volutpat and gestas posuere congue ipsum.`,
  },
  {
    title: "Skill 4",
    svg: FreeSvg,
    content: `Maecenas laoreet augue egestas laoreet augue egestas, congue gestas
          volutpat posuere cubilia congue ipsum mauris lectus laoreet gestas
          neque volutpat and gestas posuere congue ipsum.`,
  },
]

const ServiceSection = () => {
  return (
    <div
      tw="flex flex-col items-center justify-center min-h-screen  mx-auto p-5 max-w-7xl "
      id="SERVICESECTION"
    >
      <div tw="text-xl  max-w-4xl flex flex-col mt-8 mx-auto">
        Aliquam a augue suscipit, luctus neque purus ipsum neque dolor primis'
        libero tempus, tempor posuere ligula varius augue luctus lampus ronald
        messi is best virat best crickfoot bharat worl
      </div>

      <div tw="grid md:grid-cols-2 gap-4 mt-24">
        {ServiceData.map((item, index) => (
          <div key={index}>
            <div tw="text-4xl text-gray-900 flex flex-col">
              <item.svg />
              <p>{item.title}</p>
            </div>
            <p>{item.content}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ServiceSection
